import AddToMyListButton from '@molecules/AddToMyListButton/AddToMyListButton';
import SharedArticleStamp, {
  IArticleStamp,
} from '@organisms/ArticleStamp/ArticleStamp';

const ArticleStamp = (props: IArticleStamp) => (
  <SharedArticleStamp {...props} WishlistButton={AddToMyListButton} />
);

export default ArticleStamp;
